import React from 'react';

const Divider: React.FC = () => {
  return (
    <hr className="mx-4 my-4 h-px bg-gray-200 border-0" />
  );
};

export default Divider;
